import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { translate } from 'react-polyglot'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'

import { settingsActions } from 'features/settings'
import { userAchievements, teamAchievements } from 'features/achievements/types'

import EE from 'emitter.js'

import { Icon, Loader, FlexContainer, Text, Button } from 'components'

class AchievementsPage extends PureComponent {
	componentDidMount() {
		this.props.getAchievements()

		// Reset loading state
		this.props.setLoadingState(true)
	}

	ownsAchievement = type =>
		!!this.props.achievements.find(a => a.type === type)

	onClick = (a, ownsIt) => {
		const tutorial = !ownsIt
		const showAll = false

		EE.emit('showAchievementsModal', {
			...a,
			tutorial,
			showAll,
		})
	}

	renderUserAchievements = () =>
		userAchievements.map(uA => {
			const { t } = this.props
			const count = uA.achievements.filter(a =>
				this.props.achievements.find(pA => pA.type === a.type)
			).length

			if (uA.isHidden && count === 0) return null

			return (
				<div
					className="grid__item"
					data-grid="12/12"
					key={t(`achievement_groups.${uA.key}`)}
				>
					<div className="grid" data-grid="normal">
						<div className="grid__item" data-grid="12/12">
							<FlexContainer>
								<h2>{t(`achievement_groups.${uA.key}`)}</h2>
								<Text size="small" color="dark">
									{count} / {uA.achievements.length}
								</Text>
							</FlexContainer>
						</div>
						<div className="grid__item" data-grid="12/12">
							<div className="grid" data-grid="normal">
								{uA.achievements.map(a => {
									const ownsIt = this.ownsAchievement(a.type)

									if (uA.isHidden && !ownsIt) return false

									return (
										<div
											className="grid__item"
											data-grid="6/12"
											data-grid--medium="4/12"
											data-grid--large="3/12"
											data-grid--x-large="2/10"
											key={a.type}
										>
											<button
												className={classNames(
													'c-achievement__teaser',
													ownsIt
														? 'is-active'
														: 'is-inactive'
												)}
												type="button"
												onClick={() =>
													this.onClick(a, ownsIt)
												}
											>
												<div className="c-achievement__teaser-image">
													<img src={a.image} alt="" />
												</div>
												<Text
													color={
														ownsIt ? 'dark' : null
													}
												>
													{t(
														`achievements.${a.type}.title`
													)}
												</Text>
											</button>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			)
		})

	renderTeamAchievements = () =>
		teamAchievements.map(tA => {
			if (tA.isHidden) return null

			const { t } = this.props
			const count = tA.achievements.filter(a =>
				this.props.achievements.find(pA => pA.type === a.type)
			).length

			return (
				<div
					className="grid__item"
					data-grid="12/12"
					key={t(`achievement_groups.${tA.key}`)}
				>
					<div className="grid" data-grid="normal">
						<div className="grid__item" data-grid="12/12">
							<FlexContainer>
								<h2>{t(`achievement_groups.${tA.key}`)}</h2>
								<Text size="small" color="dark">
									{count} /{' '}
									{
										tA.achievements.filter(a => !a.isHidden)
											.length
									}
								</Text>
							</FlexContainer>
						</div>
						<div className="grid__item" data-grid="12/12">
							<div className="grid" data-grid="normal">
								{tA.achievements.map(a => {
									const ownsIt = this.ownsAchievement(a.type)

									return (
										<div
											className="grid__item"
											data-grid="6/12"
											data-grid--medium="4/12"
											data-grid--large="3/12"
											data-grid--x-large="2/10"
											key={a.type}
										>
											<button
												className={classNames(
													'c-achievement__teaser',
													ownsIt
														? 'is-active'
														: 'is-inactive'
												)}
												type="button"
												onClick={() =>
													this.onClick(a, ownsIt)
												}
											>
												<div className="c-achievement__teaser-image">
													<img src={a.image} alt="" />
												</div>
												<Text
													color={
														ownsIt ? 'dark' : null
													}
												>
													{t(
														`achievements.${a.type}.title`
													)}
												</Text>
											</button>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			)
		})

	render() {
		const { loading } = this.props

		if (loading) return <Loader />

		return (
			<div className="grid" data-grid="x-wide">
				{/*
						<div className="grid__item">
							// https://github.com/diegoddox/react-redux-toastr
							// https://diegoddox.github.io/react-redux-toastr/
							<button
								// success info warning error
								onClick={() => toastr.light(
									'',
									{
										timeOut: 8000000, // 0 = prevent the auto close
										onShowComplete: () => console.log('Show: animation is done'),
										onHideComplete: () => console.log('Hide: animation is done'),
										onCloseButtonClick: () => console.log('Close button was clicked'),
										onToastrClick: () => console.log('Notification was clicked'),
										removeOnHover: false,
										showCloseButton: false,

										// closeOnToastrClick: true, // false by default, this will close the toastr when user clicks on it

										component: (props) => (
											<>
												<FlexContainer alignItems="flex-start" justifyContent="flex-start">
													<img style={{ width: '2.5rem', minWidth: '2.5rem', height: 'auto' }} src="/assets/img/bird.svg" alt="" />
													<>
														<Text weight="bold" color="dark">Delete user Delete user Delete user Delete user</Text>
														<Text size="small" color="dark">Und wenn hier was ganz langes steht, dann haut das eigentlich auch noch hin, würde ich mal sagen.</Text>
														<Text color="dark">
															<Button
																onClick={console.log()}
																text="Reload app"
																layout="secondary"
																size="small"
															/>
														</Text>
													</>
												</FlexContainer>
												<Button
													className="rrt-close-button"
													onClick={props.remove}
													centerContent
													icon={<Icon name="close" />}
												/>
											</>
										),
									},
								)}
								type="button"
								className="o-button o-button--primary is-visible"
							>
								Notification test
							</button>
						</div>
					*/}

				{this.renderUserAchievements()}
				{this.renderTeamAchievements()}

				{/* <Button
					onClick={() => {
						EE.emit('showAchievementsModal', {
							type: 'FIRST_ARTICLE',
							title: 'Your first article',
							text: 'Start your journey with creating a new article',
							image: '/assets/img/achievements/won.svg',
						})
					}}
					text="Get random achievement"
					layout="ghosted"
				/> */}
			</div>
		)
	}
}

AchievementsPage.propTypes = {
	loading: PropTypes.bool.isRequired,
	setLoadingState: PropTypes.func.isRequired,
	achievements: PropTypes.arrayOf(PropTypes.object).isRequired,
	getAchievements: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
	loading: state.settings.loading,
	achievements: state.settings.achievements,
})

const mapDispatchToProps = {
	setLoadingState: settingsActions.setLoadingState,
	getAchievements: settingsActions.getAchievementsRequest,
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(translate()(AchievementsPage))
)
